import React from 'react';
import {Modal, ModalBodyProps} from '@mantine/core';

export const EtroModalBody: React.FC<ModalBodyProps> = props => {
  return <Modal.Body {...props} />;
};
